import React, { useState } from "react";
import { Link } from "react-router-dom";
//import emailjs from "@emailjs/browser";
import "./Contatos.css";

const Contatos = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setStatus("Enviando...");

//     emailjs
//       .send(
//         "YOUR_SERVICE_ID", // Substitua pelo seu Service ID do EmailJS
//         "YOUR_TEMPLATE_ID", // Substitua pelo seu Template ID do EmailJS
//         {
//           name: formData.name,
//           email: formData.email,
//           subject: formData.subject,
//           message: formData.message,
//           to_email: "custosagro@gmail.com", // Email de destino
//         },
//         "YOUR_USER_ID" // Substitua pelo seu User ID do EmailJS
//       )
//       .then(
//         (result) => {
//           setStatus("Mensagem enviada com sucesso!");
//           setFormData({ name: "", email: "", subject: "", message: "" });
//         },
//         (error) => {
//           setStatus("Erro ao enviar a mensagem. Tente novamente.");
//           console.error(error.text);
//         }
//       );
//   };

  return (
    <div className="contatos-container">
      <h1>Contatos</h1>
      <div className="contatos-content">
        <div className="contact-info">
          <h2>Nossos Contatos</h2>
          <p><strong>Email 1:</strong> lucas@custos.agro.com.br</p>
          <p><strong>Email 2:</strong> custosagro@gmail.com</p>
          <p><strong>Email 3:</strong> guilhermeeschersalvador@gmail.com</p>
        </div>
        <div className="contact-form">
          <h2>Envie-nos uma Mensagem</h2>
          <form>
            <div className="form-group">
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Seu Nome"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Seu Email"
                required
              />
            </div>
            <div className="form-group">
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Assunto"
                required
              />
            </div>
            <div className="form-group">
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                placeholder="Sua Mensagem"
                required
              />
            </div>
            <button type="submit" className="submit-button">
              Enviar Mensagem
            </button>
            {status && <p className="status-message">{status}</p>}
          </form>
        </div>
      </div>
      <Link to="/" className="back-link">Voltar para Home</Link>
    </div>
  );
};

export default Contatos;